import { useEffect, useRef, useState } from 'react';
import { CreateUnitSimpleForm } from './CreateUnitSimpleForm';
import { CreateUnitData } from '@/custom-types';
import { Col, Row } from 'react-grid-system';
import { SquareButton2 } from '../atoms';
import houseIcon from '@/assets/property-icons/house-icon.svg'
import styled from 'styled-components';
import { useCreatePropertyContext } from '@/customHooks/useCreatePropertyContext';
import { BedSizeOption, UnityStatusOption } from '@/graphql/generated';

const emptyData: CreateUnitData = {
  name: '',
  bedSize: BedSizeOption.Twin,
  privateBath: false,
  fan: false,
  airConditioner: false,
  id: 0,
}

const Wrapper = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`

const CardsContainer = styled(Col)`
  margin-bottom: 16px;
`

export const UnitCreateListTable = () => {
  const { setUnities, setButtonEnabled, setButtonDisabled, state: contextState } = useCreatePropertyContext()

  const [units, setUnits] = useState<CreateUnitData[] | null>(() => {
    if (contextState.unities && contextState.unities.length > 0) {
      return contextState.unities.map((unity, index) => ({
        id: index,
        name: unity.name,
        bedSize: unity.bedSizeOption,
        privateBath: unity.privateBathroom,
        fan: unity.fan,
        airConditioner: unity.airConditioner,
      }));
    }
    return null;
  });
  const unitsRef = useRef<CreateUnitData[] | null>(units)

  const onActionHandle = (index: number, data: CreateUnitData) => {
    setUnits((units) => units?.map((unit, i) => (i === index ? data : unit)) ?? null)
  }

  const onDeleteHandle = (indexToRemove: number) => {
    setUnits((prev) => {
      const newUnits = prev?.filter((_, index) => index !== indexToRemove);
      return newUnits && newUnits.length > 0 ? newUnits : null;
    })
  }

  const addUnit = () => {
    setUnits((prev) => [...prev || [], emptyData])
  }

  useEffect(() => {
    unitsRef.current = units;
    // Lógica de habilitación/deshabilitación
    if (units && units.length > 0) {
      setButtonEnabled();
    } else {
      setButtonDisabled();
    }
  }, [units, setButtonEnabled, setButtonDisabled]);

  useEffect(() => {
    // Guardar el estado en el contexto al desmontar
    return () => {
      // Solo actualiza el contexto si hay cambios para evitar renders innecesarios
      const finalUnits = unitsRef.current ?? [];

      setUnities(finalUnits.map((unity) => ({
        bedSizeOption: unity.bedSize,
        privateBathroom: unity.privateBath,
        name: unity.name,
        fan: unity.fan,
        airConditioner: unity.airConditioner,
        currentStatus: UnityStatusOption.Vacant
      })));
    };
  }, [setUnities]); // Dependencias estables

  return (
    <Wrapper>
      <Row>
        {
          units?.map((_, index) => (
            <CardsContainer
              key={index}
              xs={12}
            >
              <CreateUnitSimpleForm
                id={index}
                onAction={(data) => onActionHandle(index, data)}
                dropDownMenuActions={{
                  edit: (id) => console.log('edit pressed ' + id),
                  delete: (id) => onDeleteHandle(id)
                }}
              />
            </CardsContainer>
          ))
        }
      </Row>
      <Row justify="center">
        <Col xs="content">
          <SquareButton2
            action={addUnit}
          >
            <>
              <img src={houseIcon} alt="" />
              <span>Add Unit</span>
            </>
          </SquareButton2>
        </Col>
      </Row>
    </Wrapper>
  )
}